import { CompanySector } from 'src/api/types/wizard';
import { WizardFormValues } from 'src/api/types/wizard';
import { WizardQuery } from 'src/graphql/_generated';

export const convertQuestionsToWizardFormValues = (
  questions: NonNullable<WizardQuery['profile']['activeWorkspace']>['questions'],
): WizardFormValues => {
  return {
    organisation: {
      sector: (questions?.organisation?.sector as CompanySector) || undefined,
      usesManagedServiceProvider: !!questions?.organisation?.usesManagedServiceProvider,
    },
    customers: {},
    softwareDev: {
      developsSoftware: !!questions?.softwareDev?.developsSoftware,
    },
    supplyChain: {},
    cyberInsurance: {
      cyberInsurance: !!questions?.cyberInsurance?.cyberInsurance,
    },
    regulations: {
      legislation: questions?.regulations?.legislation || [],
      controlFrameworks: questions?.regulations?.controlFrameworks || [],
      controlFrameworksOther: questions?.regulations?.controlFrameworksOther || [],
      primaryControlFramework: questions?.regulations?.primaryControlFramework || undefined,
      primaryFrameworkControls: questions?.regulations?.primaryFrameworkControls || [],
      pinnedControlFrameworks: questions?.regulations?.pinnedControlFrameworks || [],
    },
    scenarios: {
      B2B: !!questions?.scenarios?.B2B,
      B2C: !!questions?.scenarios?.B2C,
      publiclyAccessibleInternetBusiness: !!questions?.scenarios?.publiclyAccessibleInternetBusiness,
      paymentVolumeOrValue: !!questions?.scenarios?.paymentVolumeOrValue,
      significantITContributionToRevenue: !!questions?.scenarios?.significantITContributionToRevenue,
      significantDataInCloud: !!questions?.scenarios?.significantDataInCloud,
      softwareBusiness: !!questions?.scenarios?.softwareBusiness,
      cniOrDefenseInvolvement: !!questions?.scenarios?.cniOrDefenseInvolvement,
      significantRandD: !!questions?.scenarios?.significantRandD,
      regulated: !!questions?.scenarios?.regulated,
      operationalTechnology: !!questions?.scenarios?.operationalTechnology,
      supplyChainReliant: !!questions?.scenarios?.supplyChainReliant,
      aiThirdPartyReliant: !!questions?.scenarios?.aiThirdPartyReliant,
      aiCustomerFacingApp: !!questions?.scenarios?.aiCustomerFacingApp,
    },
    assessment: {
      name: questions?.assessment?.name || undefined,
      description: questions?.assessment?.description || undefined,
      started_date: questions?.assessment?.started_date || undefined,
    },
  };
};
